<form #f="ngForm" (ngSubmit)=" saveNews()">
    <div class="p-grid">
        <div class="p-col-12 error-notify-text">
            <app-validateform [formToValidate]="addNewsForm"></app-validateform>
        </div>
        <div class="p-col-12 page-header">New Home Page News Message</div>
        <div class="p-col-12 divider-header">
            <p-divider></p-divider>
        </div>
        <div class="p-col-12">
            <div class="p-grid">
                <div class="p-col-6 p-lg-2 p-md-2 p-sm-2">
                    <button pButton type="submit" class="fullwidthbtn" label="Save"></button>
                </div>
                <div class="p-col-6 p-lg-2 p-md-2 p-sm-2">
                    <button pButton type="button" class="fullwidthbtn" label="Cancel" (click)="cancelAddNews()"></button>
                </div>
            </div>
            <div class="">
                <p-panel header="MESSAGE">
                    <div class="p-grid" *ngIf="newsTypeOptions">
                        <div class="p-col-12">
                            <span class="p-float-label">
                                <p-dropdown inputId="dropdown"
                                            [autoDisplayFirst]="false"
                                            [showClear]="true"
                                            [options]="newsTypeOptions"
                                            [(ngModel)]="news.NewsMessageTypeID"
                                            name="SelectNewsType"
                                            required
                                            data-display-name="News Type">
                                </p-dropdown>
                                <label for="dropdown">News Type*</label>
                            </span>
                        </div>
                        <div class="p-col-12">
                            <span class="p-float-label">
                                <input type="text"
                                       pInputText
                                       [(ngModel)]="news.HeadLine"
                                       name="Subject"
                                       requiredNoSpaceValidator
                                       data-display-name="Subject" />
                                <label for="float-input">Subject*</label>
                            </span>
                        </div>
                        <div class="p-col-12">
                            <p-editor placeholder="Body"
                                      [(ngModel)]="news.BroadcastBody"
                                      [style]="{'height':'320px'}"
                                      name="Body"></p-editor>
                        </div>
                    </div>
                </p-panel>
                <p-panel header="ATTACHMENTS">
                    <div class="p-grid">
                        <div class="p-col-12">
                            <p-fileUpload name="myfile[]"
                                          url="{{uploadURL}}"
                                          multiple="multiple"
                                          chooseLabel="Add Files"
                                          [showUploadButton]="false"
                                          (onBeforeUpload)="onBeforeUpload($event)"
                                          (onUpload)="onUploadCompleted($event)">
                            </p-fileUpload>
                        </div>
                    </div>
                </p-panel>


            </div>
        </div>
    </div>
</form>
<p-confirmDialog header="Confirmation" key="AddNewsConfirmDialog" icon="pi pi-exclamation-triangle"></p-confirmDialog>
